import { useMutation } from '@tanstack/react-query';

import { switchAccount } from '@/api/v4/auth.api';
import { queryClient } from '@/config/query-client';
import { resetMixpanel } from '@/lib/mixpanel/mixpanel';
import { useNavigateTo } from '@/routes/hooks/use-navigate-to';
import { notify } from '@/ui/snackbar/notify';
import { useTranslation } from 'react-i18next';

export const useSwitchAccount = (options?: {
  skipHomeNavigation?: boolean;
}) => {
  const { t } = useTranslation('default');

  const navigateTo = useNavigateTo();

  return useMutation({
    mutationFn: async (userInAccountId: number) => {
      await queryClient.cancelQueries();

      // Only navigate to home if not automatic switch
      if (!options?.skipHomeNavigation) {
        navigateTo.home();
      }

      return switchAccount({
        userInAccountId,
      });
    },
    onSuccess: async () => {
      resetMixpanel();
      await queryClient.resetQueries();
    },
    onError: () => {
      notify({
        message: t`unknownError`,
      });
    },
  });
};
